var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEventScheduled = function SvgEventScheduled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#paint0_linear_1358_21946)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0005 10.2852C16.6317 10.2852 17.1434 10.7968 17.1434 11.428V16.6689L19.0944 18.6199C19.5407 19.0662 19.5407 19.7898 19.0944 20.2361C18.648 20.6824 17.9244 20.6824 17.4781 20.2361L14.8577 17.6157V11.428C14.8577 10.7968 15.3693 10.2852 16.0005 10.2852Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0002 25.1417C21.0496 25.1417 25.143 21.0483 25.143 15.9989C25.143 10.9494 21.0496 6.85603 16.0002 6.85603C10.9507 6.85603 6.85729 10.9494 6.85729 15.9989C6.85729 21.0483 10.9507 25.1417 16.0002 25.1417ZM16.0002 27.4275C22.312 27.4275 27.4287 22.3107 27.4287 15.9989C27.4287 9.68706 22.312 4.57031 16.0002 4.57031C9.68832 4.57031 4.57158 9.68706 4.57158 15.9989C4.57158 22.3107 9.68832 27.4275 16.0002 27.4275Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1358_21946",
    x1: 8.42105,
    y1: 3.36842,
    x2: 28.6316,
    y2: 29.4737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA06A"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEventScheduled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eventScheduled.25188944e9a213c56724139c87d49708.svg";